import { PageMeta } from '@/components/PageMeta';
import CguSections1 from '@/components/cgu-cgv/CguSections1';
import CguSections2 from '@/components/cgu-cgv/CguSections2';
import { FileText } from 'lucide-react';

const tocItems = [
  { id: 'objet', label: '1. Objet et éditeur' },
  { id: 'definitions', label: '2. Définitions' },
  { id: 'inscription', label: '3. Inscription et compte' },
  { id: 'services', label: '4. Services et plans' },
  { id: 'tarifs', label: '5. Tarifs et facturation' },
  { id: 'stripe-connect', label: '6. Paiements Stripe Connect' },
  { id: 'retractation', label: '7. Droit de rétractation' },
  { id: 'remboursements', label: '8. Remboursements et annulations' },
  { id: 'responsabilites', label: '9. Responsabilités' },
  { id: 'donnees', label: '10. Données personnelles' },
  { id: 'propriete', label: '11. Propriété intellectuelle' },
  { id: 'resiliation', label: '12. Résiliation' },
  { id: 'modification', label: '13. Modification des CGU' },
  { id: 'droit', label: '14. Droit applicable' },
  { id: 'contact', label: '15. Contact' },
];

export default function CguCgv() {
  return (
    <>
      <PageMeta
        title="Conditions Générales d'Utilisation et de Vente"
        description="Conditions générales d'utilisation et de vente BoulesConnect : abonnements, paiements Stripe Connect, remboursements, responsabilités et droit applicable."
        robots='index, follow'
      />
      {/* Hero */}
      <section className='pt-40 pb-16 px-6'>
        <div className='max-w-4xl mx-auto text-center'>
          <div className='inline-flex items-center gap-2 bg-blue-50 border border-blue-100 px-4 py-2 rounded-full mb-6'>
            <FileText className='w-4 h-4 text-blue-600' />
            <span className='text-xs font-bold text-blue-700 uppercase tracking-wider'>Conditions générales</span>
          </div>
          <h1 className='text-3xl md:text-5xl font-extrabold text-slate-900 mb-4'>
            Conditions Générales d&apos;Utilisation et de Vente
          </h1>
          <p className='text-lg text-slate-500'>Dernière mise à jour : 12 juin 2026</p>
        </div>
      </section>

      {/* Content with sidebar */}
      <section className='px-6 pb-20'>
        <div className='max-w-6xl mx-auto flex gap-8'>
          {/* TOC sidebar */}
          <aside className='hidden lg:block w-64 flex-shrink-0'>
            <div className='sticky top-32'>
              <h3 className='text-sm font-bold text-slate-900 mb-4'>Sommaire</h3>
              <nav className='space-y-1'>
                {tocItems.map(item => (
                  <a
                    key={item.id}
                    href={`#${item.id}`}
                    className='block px-3 py-2 text-sm text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-colors'
                  >
                    {item.label}
                  </a>
                ))}
              </nav>
            </div>
          </aside>

          {/* Main content */}
          <div className='flex-1 min-w-0 space-y-8'>
            <CguSections1 />
            <CguSections2 />
          </div>
        </div>
      </section>
    </>
  );
}
